import { render, staticRenderFns } from "./shareFile.vue?vue&type=template&id=56bfcb4e"
import script from "./shareFile.vue?vue&type=script&lang=js"
export * from "./shareFile.vue?vue&type=script&lang=js"
import style0 from "./shareFile.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports